import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { getBanners, deleteBanner } from "../../apis";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";
import Pagination from "../../components/Pagination/Pagination";
import AddEdit from "./AddEdit";

const Admins = ({ logoutRequest, startLoadingRequest, stopLoadingRequest }) => {
  // Initialize data as an array
  const [data, setData] = useState([]);
  const { pathname, search } = useLocation();

  // State to control full screen image modal
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const fetch = useCallback(async () => {
    try {
      const apiResponse = await getBanners(search);
      console.log("apiResponse", apiResponse.data.data);
      if (apiResponse?.data?.data?.length > 0) {
        setData(apiResponse.data.data);
      } else {
        setData([]);
      }
      stopLoadingRequest();
    } catch (error) {
      if (error?.response?.status === 401) {
        toast.error(error.response.data.message);
        logoutRequest();
      } else if (error?.response?.status === 403) {
        toast.error(error.response.data.message);
      }
      stopLoadingRequest();
    }
  }, [search, pathname, logoutRequest, stopLoadingRequest]);

  useEffect(() => {
    startLoadingRequest();
    fetch();
  }, [pathname, search, fetch, startLoadingRequest]);

  // Delete handler for banners
  const deleteBannerHandler = useCallback(
    async (id) => {
      try {
        startLoadingRequest();
        await deleteBanner(id);
        toast.success("Banner deleted successfully");
        fetch();
      } catch (error) {
        if (error?.response?.status === 401) {
          toast.error(error.response.data.message);
          logoutRequest();
        } else if (error?.response?.status === 403) {
          toast.error(error.response.data.message);
        }
        stopLoadingRequest();
      }
    },
    [fetch, logoutRequest, startLoadingRequest, stopLoadingRequest]
  );

  // Open modal to display full-screen image
  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImageModalOpen(true);
  };

  // Close full-screen image modal
  const closeImageModal = () => {
    setImageModalOpen(false);
    setSelectedImage("");
  };

  return (
    <div className="section">
      <h1>Planner Banner</h1>
      <div className="wrapper">
        <div className="table-wrapper">
          <div className="table-header">
            {/* Button for adding a new banner */}
            <AddEdit type={"banner-add"} fetch={fetch} />
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Start Date</th>
                  <th>Event Date</th>
                  <th>End Date</th>
                  <th>City</th>
                  <th>Active/Inactive</th>
                  {/* <th>Created At</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item._id}>
                    <td>{index + 1}</td>
                    <td className="banner-image">
                      {item.bannerImage && (
                        <img
                          src={item.bannerImage}
                          alt={item.name}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "50%",
                            cursor: "pointer",
                          }}
                          onClick={() => openImageModal(item.bannerImage)}
                        />
                      )}
                    </td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{new Date(item.startDate).toLocaleDateString()}</td>
                    <td>{new Date(item.eventDate).toLocaleDateString() || "N/A"}</td>
                    <td>{new Date(item.endDate).toLocaleDateString()}</td>
                    <td>{item.city}</td>
                    <td>  {new Date() >= new Date(item.startDate) && new Date() <= new Date(item.endDate)
                      ? <span style={{color:'green'}}>Active</span>
                      : <span>InActive</span>}</td>
                    {/* <td>{new Date(item.createdAt).toLocaleDateString()}</td> */}
                    <td>
                      <div className="table-actions">
                        {/* Edit button passes current banner data to the modal */}
                        <AddEdit
                          type={`Banner-${item._id}`}
                          data={item}
                          fetch={fetch}
                        />
                        <button
                          className="danger"
                          onClick={() => deleteBannerHandler(item._id)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Uncomment and configure Pagination if needed */}
          {/* <Pagination pageInfo={data.pageInfo} /> */}
        </div>
      </div>

      {/* Full-screen Image Modal */}
      {imageModalOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeImageModal}
        >
          <img
            src={selectedImage}
            alt="Full Screen"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
            }}
          />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(Admins);
